export const BASE_URL = process.env.REACT_APP_URL;
export const ENV = process.env.REACT_APP_ENV;